export default {
    token: null,
    username: null,
    loggedIn: false,
}